import { Link as LinkIcon } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import {
  ApproveReserveOrderLinkModal,
  useApproveReserveOrderLinkModalStore
} from 'modules/orders/components/ApproveReserveOrderLinkModal'
import { ActionsItemProps } from './actions'

export const ApproveReserveOrderLink = ({
  order,
  disabled
}: ActionsItemProps) => {
  const isModalOpen = useApproveReserveOrderLinkModalStore.useIsModalOpen()
  const setModalIsOpen =
    useApproveReserveOrderLinkModalStore.useSetModalIsOpen()
  const setProposalId = useApproveReserveOrderLinkModalStore.useSetProposalId()

  const handleClick = () => {
    setModalIsOpen(true)
    setProposalId(order.proposalId)
  }

  return (
    <>
      <MenuItem onClick={handleClick} disableRipple disabled={disabled}>
        <LinkIcon />
        Aprovar Reserva
      </MenuItem>

      {isModalOpen && <ApproveReserveOrderLinkModal />}
    </>
  )
}
